import SrDialogAddOptions from "./SrDialogAddOptions.vue";

SrDialogAddOptions.install = function(Vue) {
  Vue.component(SrDialogAddOptions.name, SrDialogAddOptions);
};

export default SrDialogAddOptions;


// WEBPACK FOOTER //
// ./packages/SrDialogAddOptions/index.js